
    <!--
 * 竖版-活动任务
 * @LastEditTime: Tue Dec 17 2024 15:43:03 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_DIDC46"  :class="[`normal teamTaskSection main-color`,`u_c_DIDC46`]" ><div id="u_c_TCEI47"  :class="[`${ compData.title ? 'text' : '' }`,`normal task-title`,`u_c_TCEI47`]" ><div id="u_c_OCV248"  :class="[compData.activeTab == 'team' ? 'active-tab' : '',`normal`,`u_c_OCV248`]" @click="u_c_OCV248_event_AXJ783($event)">{{langData.teamTask}}</div><div id="u_c_MHT350"  :class="[compData.activeTab == 'personal' ? 'active-tab' : '',`normal`,`u_c_MHT350`]" @click="u_c_MHT350_event_XSXX85($event)">{{langData.personalTask}}</div></div><div id="u_c_H0UU52"  :class="[`normal task-desc`,`u_c_H0UU52`]" ><div id="u_c_Q9IQ53"  v-html="compData.inviterDesc || langData.teamTaskDesc" v-if="compData.activeTab == 'team'" :class="[`normal`,`u_c_Q9IQ53`]" ></div><div id="u_c_RB2H54"  v-html="compData.inviteeDesc || langData.personalTaskDesc" v-if="compData.activeTab == 'personal'" :class="[`normal`,`u_c_RB2H54`]" ></div></div><div id="u_c_77JA97"  :class="[`normal`,`u_c_77JA97`]" >{{langData.curProgress}}<span id="u_c_A786102"  :class="[`normal highlight`,`u_c_A786102`]" >{{`${ compData.activeTab == 'team' ? pageData.teamPayTotal : pageData.personalPayTotal } ${ pageData.currency }`}}</span></div><div id="u_c_Q26230"  :class="[`normal txt main-color`,`u_c_Q26230`]" ><span id="u_c_KL1C31"  :class="[`normal txt`,`u_c_KL1C31`]" @click="u_c_KL1C31_event_Y90J29($event)">{{`[${ langData.refresh }]`}}</span><span id="u_c_JGIQ33"  :class="[`normal txt`,`u_c_JGIQ33`]" @click="u_c_JGIQ33_event_Y90J29($event)">{{`[${ langData.myPackage }]`}}</span><span id="u_c_6R6U21"  :class="[`normal txt`,`u_c_6R6U21`]" @click="u_c_6R6U21_event_Y90J29($event)">{{`[${ langData.taskLog }]`}}</span></div><div id="u_c_EQ6B133"  :class="[`normal`,`u_c_EQ6B133`]" ><div id="u_c_0PIV116"  v-for="(groupItem, groupIndex) in (compData.activeTab == 'team' ? compData.teamTask : compData.soloTask)" :key="groupIndex" :class="[`normal main-color`,`u_c_0PIV116`]" ><div id="u_c_IXM3117"  v-if="pageData.isEdit" :class="[`normal task-text `,`u_c_IXM3117`]" ><div id="u_c_PHDI21"  v-html="(groupItem.payLevelType == 'customize_level' ? langData.teamPayTotal : langData.teamPayEvery).replace('${x}${currency}', `<span class='highlight'> ${ groupItem.num || 0 } ${ pageData.currency }</span>`)" :class="[`normal`,`u_c_PHDI21`]" ></div></div><div id="u_c_C09Q26"  v-if="!pageData.isEdit" v-html="groupItem.taskName || langData[groupItem.taskValue]" :class="[`normal task-text`,`u_c_C09Q26`]" ></div><div id="u_c_9F94121"  :class="[`normal`,`u_c_9F94121`]" ><div id="u_c_8YAC122"  :class="[`normal`,`u_c_8YAC122`]" ><div id="u_c_67LY123"  v-for="(awardItem, awardIndex) in groupItem.pic" :key="awardIndex" :class="[`normal`,`u_c_67LY123`]" @click="u_c_67LY123_event_QUFC21($event,groupItem)"><div id="u_c_CIKY124"  :style="`background-image:url(${ awardItem })`" :class="[`normal`,`u_c_CIKY124`]" ></div></div></div><div id="u_c_5EOB125"  v-html="pageData.isEdit ? langData.toFinish : getBtnText(groupItem)" :class="[groupItem.state == 2 ? 'has' : '',`normal`,`u_c_5EOB125`]" @click="u_c_5EOB125_event_5IW625($event,groupItem,groupIndex)"></div></div><div id="u_c_SGL619"  :class="[`normal`,`u_c_SGL619`]" ><span id="u_c_LM5020"  v-if="groupItem.taskValue === 'pay_order'" :class="[`normal`,`u_c_LM5020`]" >{{langData.orderMoneyNoLimit}}</span><span id="u_c_U4BS22"  v-if="+groupItem.dailyLimit != -1" :class="[`normal`,`u_c_U4BS22`]" >{{+groupItem.dailyLimit ? langData.dayLimit.replace('${x}', groupItem.dailyLimit) : langData.dayNoLimit}}</span><span id="u_c_YLSD24"  v-if="+groupItem.activityLimit != -1" :class="[`normal`,`u_c_YLSD24`]" >{{+groupItem.activityLimit ? langData.activityLimit.replace('${Y}', groupItem.activityLimit) : langData.activityNoLimit}}</span></div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"请先在规则配置中配置自定义事件","eventName":"请按照规则配置顺序配置自定义事件名称"}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"","payLevelType":"fixed_level","num":1,"pic":["https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png"],"awardDetail":"","state":"0","dailyLimit":0,"activityLimit":0}],"soloTask":[{"taskValue":"pay_total","payLevelType":"","taskName":"","pic":["https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1713171812387-30.png"],"awardDetail":"","state":"0","dailyLimit":0,"activityLimit":0}]},"zh-CN":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"加速训练10分钟*10\n研究加速10分钟*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"钻石*50\n加速训练10分钟*10\n研究加速10分钟*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"钻石*100\n加速训练10分钟*10\n研究加速10分钟*10\n加速建造10分钟*10 ","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"钻石*200\n5星英雄万能碎片*2\n加速训练10分钟*10\n研究加速10分钟*10\n加速建造10分钟*10 ","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"加速训练10分钟*10\n研究加速10分钟*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"钻石*150\n加速训练10分钟*10\n研究加速10分钟*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"钻石*200\n5星英雄万能碎片*5\n升星选择补给箱*10\n强化选择补给箱*10  ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"钻石*300\n5星英雄万能碎片*8\n精密升星选择补给箱*10\n升星选择补给箱*10\n强化选择补给箱*10  ","state":"0","dailyLimit":"","activityLimit":"1"}]},"zh-TW":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"加速訓練10分鐘*10\n研究加速10分鐘*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"鑽石*50\n加速訓練10分鐘*10\n研發加速10分鐘*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"鑽石*100\n加速訓練5分鐘*10\n研發加速5分鐘*10\n加速建造5分鐘*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"鑽石*200\n5星英雄萬能碎片*2\n加速訓練5分鐘*10\n研發加速5分鐘*10\n加速建造5分鐘*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"加速訓練10分鐘*10\n研究加速10分鐘*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"鑽石*150\n加速訓練10分鐘*10\n研發加速10分鐘*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"鑽石*200\n5星英雄萬能碎片*5\n升星選擇補給箱*10\n強化選擇補給箱*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"鑽石*300\n5星英雄萬能碎片*8\n精密升星選擇補給箱*10\n升星選擇補給箱*10\n強化選擇補給箱*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"en-US":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":500,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"Training Speedup 10-min*10\nResearch Speedup 10-min*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":1500,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamond*50\n10-min Training Speedup*10\n10-min Research Speedup*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":3000,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamond*100\n5-min Training Speedup*10\n5-min Research Speedup*10\n5-min Build Speedup*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":5000,"pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamond*200\n5★ Hero Perfect Frag*2\n5-min Training Speedup*10\n5-min Research Speedup*10\n5-min Build Speedup*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"Training Speedup 10-min*10\nResearch Speedup 10-min*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"Diamond*150\n10-min Training Speedup*10\n10-min Research Speedup*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"Diamond*200\n5★ Hero Perfect Frag*5\nPromote Choice Box*10\nEnhance Choice Box*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"Diamond*300\n5★ Hero Perfect Frag*8\nPromote Choice Box II*10\nPromote Choice Box*10\nEnhance Choice Box*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"ja-JP":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"トレーニング加速10分間*10\n研究加速10分間*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"ダイヤ*50\n訓練ブースト（10分間）*10\n研究ブースト（10分間）*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"ダイヤ*100\n訓練ブースト（5分間）*10\n研究ブースト（5分間）*10\n建造ブースト（5分間）*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"ダイヤ*200\n★5英雄の万能欠片*2\n訓練ブースト（5分間）*10\n研究ブースト（5分間）*10\n建造ブースト（5分間）*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"トレーニング加速10分間*10\n研究加速10分間*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"ダイヤ*150\n訓練ブースト（10分間）*10\n研究ブースト（10分間）*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"ダイヤ*200\n★5英雄の万能欠片*5\n選択型プロモート補給*10\n選択型強化補給*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"ダイヤ*300\n★5英雄の万能欠片*8\n選択型プロモート補給（エリート）*10\n選択型プロモート補給*10\n選択型強化補給*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"ko-KR":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"훈련 10분 가속*10\n연구 10분 가속*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"다이아*50\n훈련 10분 가속*10\n개발 10분 가속*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"다이아*100\n훈련 5분 가속*10\n개발 5분 가속*10\n건설 5분 가속*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"다이아*200\n5성 영웅 만능 조각*2\n훈련 5분 가속*10\n개발 5분 가속*10\n건설 5분 가속*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"훈련 10분 가속*10\n연구 10분 가속*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"다이아*150\n훈련 10분 가속*10\n개발 10분 가속*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"다이아*200\n5성 영웅 만능 조각*5\n승성 선택 보급 상자*10\n강화 선택 보급 상자*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"다이아*300\n5성 영웅 만능 조각*8\n정밀 승성 선택 보급 상자*10\n승성 선택 보급 상자*10\n강화 선택 보급 상자*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"th-TH":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"เร่งสปีดฝึก10นาที *10、 เร่งสปีดการวิจัย10นาที *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"เพชร *50、 เร่งสปีดฝึก10นาที *10、 เร่งสปีดการวิจัย10นาที *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"เพชร *100、 เร่งสปีดฝึก10นาที *10、 เร่งสปีดการวิจัย10นาที *10、 เร่งสปีดสร้าง10นาที *10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"เพชร *200、 เร่งสปีดฝึก10นาที *10、 เร่งสปีดการวิจัย10นาที *10、 เร่งสปีดสร้าง10นาที *10、 เศษ Marcus *1","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"เร่งสปีดฝึก10นาที *10、 เร่งสปีดการวิจัย10นาที *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"เพชร *200、 เร่งสปีดฝึก60นาที *10、 เร่งสปีดการวิจัย60นาที *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"ชิปวิเศษฮีโร่ 5★*5、หีบเลือกอัปดาว *10、หีบเลือกตีบวก *10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"เศษ Marcus *2、 หีบเลือกอัปดาวก่อสร้าง *10、 หีบเลือกอัปดาว *10、 หีบเลือกตีบวก *10","state":"0","dailyLimit":"","activityLimit":"1"}]},"vi-VN":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"Tăng tốc huấn luyện 10 phút*10\nNghiên Cứu tăng tốc 10 phút*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Kim Cương*50\nTăng tốc huấn luyện 10 phút*10\nTăng tốc nghiên cứu 10 phút*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Kim Cương*100\nTăng tốc huấn luyện 5 phút*10\nTăng tốc nghiên cứu 5 phút*10\nTăng tốc xây 5 phút*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Kim Cương*200\nMảnh Anh hùng 5 Sao Vạn Năng*2\nTăng tốc huấn luyện 5 phút*10\nTăng tốc nghiên cứu 5 phút*10\nTăng tốc xây 5 phút*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"Tăng tốc huấn luyện 10 phút*10\nNghiên Cứu tăng tốc 10 phút*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"Kim Cương*150\nTăng tốc huấn luyện 10 phút*10\nTăng tốc nghiên cứu 10 phút*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"Kim Cương*200\nMảnh Anh hùng 5 Sao Vạn Năng*5\nRương Lựa Chọn Tăng Sao*10\nRương Chọn Cường Hoá*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"Kim Cương*300\nMảnh Anh hùng 5 Sao Vạn Năng*8\nRương Chọn Tăng Sao Tinh Vi*10\nRương Lựa Chọn Tăng Sao*10\nRương Chọn Cường Hoá*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"de-DE":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"Trainingsbeschleunigung 10 Min.*10\nForschungsbeschleunigung 10 Min.*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamant*50\n10 Min Training Beschleunigen*10\n10 Min Forschung Beschleunigen*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamant*100\n5 Min Training Beschleunigen*10\n5 Min Forschung Beschleunigen*10\n5 Min Bau Beschleunigen*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamant*200\n5★ Held-Perfektes Fragment*2\n5 Min Training Beschleunigen*10\n5 Min Forschung Beschleunigen*10\n5 Min Bau Beschleunigen*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"Trainingsbeschleunigung 10 Min.*10\nForschungsbeschleunigung 10 Min.*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"Diamant*150\n10 Min Training Beschleunigen*10\n10 Min Forschung Beschleunigen*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"Diamant*200\n5★ Held-Perfektes Fragment*5\nBefördern Auswahlkiste*10\nVerbessern Auswahlkiste*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"Diamant*300\n5★ Held-Perfektes Fragment*8\nBefördern Auswahlkiste II*10\nBefördern Auswahlkiste*10\nVerbessern Auswahlkiste*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"fr-FR":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"Accélération d’entraînement 10 m*10\nAccélération de recherche 10 m*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamant*50\nAccélération entraînement 10-min*10\nAccélération recherche 10-min*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamant*100\nAccélération entraînement 5-min*10\nAccélération recherche 5-min*10\nAccélération bâtiment 5-min*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamant*200\nFragment parfait de héros 5★*2\nAccélération entraînement 5-min*10\nAccélération recherche 5-min*10\nAccélération bâtiment 5-min*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"Accélération d’entraînement 10 m*10\nAccélération de recherche 10 m*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"Diamant*150\nAccélération entraînement 10-min*10\nAccélération recherche 10-min*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"Diamant*200\nFragment parfait de héros 5★*5\nBoîte choix promotion*10\nBoîte de renforcement au choix*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"Diamant*300\nFragment parfait de héros 5★*8\nBoîte choix promotion II*10\nBoîte choix promotion*10\nBoîte de renforcement au choix*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"ru-RU":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"10-мин. Ускорение Обучения*10\n10-мин. Ускорение Исследований*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Алмаз*50\nУскорение Обучения (10 мин.)*10\nУскорение Исследования (10 мин.)*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Алмаз*100\nУскорение Обучения (5 мин.)*10\nУскорение Исследования (5 мин.)*10\nУскорение Строительства (5 мин.)*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Алмаз*200\nИдеальный Фрагмент 5★ Героя*2\nУскорение Обучения (5 мин.)*10\nУскорение Исследования (5 мин.)*10\nУскорение Строительства (5 мин.)*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"10-мин. Ускорение Обучения*10\n10-мин. Ускорение Исследований*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"Алмаз*150\nУскорение Обучения (10 мин.)*10\nУскорение Исследования (10 мин.)*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"Алмаз*200\nИдеальный Фрагмент 5★ Героя*5\nЯщик с Промоутерами на Выбор*10\nЯщик с Улучшениями на Выбор*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"Алмаз*300\nИдеальный Фрагмент 5★ Героя*8\nЯщик с Промоутерами на Выбор 2*10\nЯщик с Промоутерами на Выбор*10\nЯщик с Улучшениями на Выбор*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"es-ES":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"10 min de Aceleración de Entrenamiento*10\n10 min de Aceleración de investigación*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamante*50\n10 min de Aceleración de Entrenamiento*10\n10 min de Aceleración de investigación*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamante*100\n5 min de Aceleración de Entrenamiento*10\n5 min de Aceleración de investigación*10\n5 min de Aceleración de Construcción*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamante*200\nFrag. Perfecto de Héroe 5★*2\n5 min de Aceleración de Entrenamiento*10\n5 min de Aceleración de investigación*10\n5 min de Aceleración de Construcción*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"10 min de Aceleración de Entrenamiento*10\n10 min de Aceleración de investigación*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"Diamante*150\n10 min de Aceleración de Entrenamiento*10\n10 min de Aceleración de investigación*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"Diamante*200\nFrag. Perfecto de Héroe 5★*5\nScatola Scelta Promozione*10\nMejora la Caja de Selección*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"Diamante*300\nFrag. Perfecto de Héroe 5★*8\nCaja de Selección de Promoción II*10\nScatola Scelta Promozione*10\nMejora la Caja de Selección*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"pt-PT":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"10 min de Aceleração de Treinamento*10\n10 min de aceleração da Pesquisa*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamante*50\n10 min de Aceleração de Treinamento*10\n10 min de aceleração da Pesquisa*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamante*100\n5 min de Aceleração de Treinamento*10\n5 min de aceleração da Pesquisa*10\n5 minutos de Aceleração de Construção*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamante*200\nFragmento de Herói Perfeito 5★*2\n5 min de Aceleração de Treinamento*10\n5 min de aceleração da Pesquisa*10\n5 minutos de Aceleração de Construção*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"10 min de Aceleração de Treinamento*10\n10 min de aceleração da Pesquisa*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"Diamante*150\n10 min de Aceleração de Treinamento*10\n10 min de aceleração da Pesquisa*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"Diamante*200\nFragmento de Herói Perfeito 5★*5\nCaixa de Escolha de Promoção*10\nCaixa da Escolha de Melhorias*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"Diamante*300\nFragmento de Herói Perfeito 5★*8\nCaixa de Escolha de Promoção II*10\nCaixa de Escolha de Promoção*10\nCaixa da Escolha de Melhorias*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"it-IT":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"Velocizz. Addestramento 10-min*10\nVelocizz. Ricerca 10-min*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamante*50\nVelocizz. Addestramento 10-min*10\nVelocizz. Ricerca 10-min*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamante*100\nVelocizz. Addestramento 5-min*10\nVelocizz. Ricerca 5-min*10\nVelocizz. Costruzione 5-min*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamante*200\nFramm. Eroe Perfetto 5★*2\nVelocizz. Addestramento 5-min*10\nVelocizz. Ricerca 5-min*10\nVelocizz. Costruzione 5-min*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"Velocizz. Addestramento 10-min*10\nVelocizz. Ricerca 10-min*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"Diamante*150\nVelocizz. Addestramento 10-min*10\nVelocizz. Ricerca 10-min*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"Diamante*200\nFramm. Eroe Perfetto 5★*5\nScatola Scelta Promozione*10\nScatola Scelta Migliora*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"Diamante*300\nFramm. Eroe Perfetto 5★*8\nScatola Scelta Promozione II*10\nScatola Scelta Promozione*10\nScatola Scelta Migliora*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"tr-TR":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"10-dk Eğitim Hızlandırma*10\n10-dk Araştırma Hızlandırma*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Elmas*50\n10-dk Eğitim Hızlandırma*10\n10-dk Araştırma Hızlandırma*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Elmas*100\n5-dk Eğitim Hızlandırma*10\n5-dk Araştırma Hızlandırma*10\n5-dk İnşa Hızlandırma*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Elmas*200\n5★ Kahraman Mükemmel Parça*2\n5-dk Eğitim Hızlandırma*10\n5-dk Araştırma Hızlandırma*10\n5-dk İnşa Hızlandırma*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"10-dk Eğitim Hızlandırma*10\n10-dk Araştırma Hızlandırma*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"Elmas*150\n10-dk Eğitim Hızlandırma*10\n10-dk Araştırma Hızlandırma*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"Elmas*200\n5★ Kahraman Mükemmel Parça*5\nİlerletme Seçim Kutusu*10\nBüyütme Seçimi Kutusu*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"Elmas*300\n5★ Kahraman Mükemmel Parça*8\nİlerletme Seçim Kutusu II*10\nİlerletme Seçim Kutusu*10\nBüyütme Seçimi Kutusu*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"pl-PL":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"10-min. Przyśpieszenie Szkolenia*10\n10-min. Przyśpieszenie Badań*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diament*50\n10-min. Przyśpieszenie Szkolenia*10\n10-min. Przyśpieszenie Badań*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diament*100\n5-min. Przyśpieszenie Szkolenia*10\n5-min. Przyśpieszenie Badań*10\n5-min. Przyśpieszenie Budowania*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diament*200\nIdealny Frag. 5★ Herosa*2\n5-min. Przyśpieszenie Szkolenia*10\n5-min. Przyśpieszenie Badań*10\n5-min. Przyśpieszenie Budowania*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"10-min. Przyśpieszenie Szkolenia*10\n10-min. Przyśpieszenie Badań*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"Diament*150\n10-min. Przyśpieszenie Szkolenia*10\n10-min. Przyśpieszenie Badań*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"Diament*200\nIdealny Frag. 5★ Herosa*5\nPudełko z Wyborem Promocji*10\nPudło Wyboru Wzmocnienia*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"Diament*300\nIdealny Frag. 5★ Herosa*8\nPudełko z Wyborem Promocji II*10\nPudełko z Wyborem Promocji*10\nPudło Wyboru Wzmocnienia*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"id-ID":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"Speed up Training 10 menit*10\nSpeed up R&D 10 menit*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"Diamond*50\nSpeed up Training 10 menit*10Speed up R&D 10 menit*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamond*100\nSpeed up Training 5 menit*10\nSpeed up R&D 5 menit*10\nSpeed up Pembangunan 5 menit*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"Diamond*200\nFragmen Hero Universal 5★*2\nSpeed up Training 5 menit*10\nSpeed up R&D 5 menit*10\nSpeed up Pembangunan 5 menit*10","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"Speed up Training 10 menit*10\nSpeed up R&D 10 menit*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"Diamond*150\nSpeed up Training 10 menit*10Speed up R&D 10 menit*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"Diamond*200\nFragmen Hero Universal 5★*5\nStar up Choice Supply Box*10\nEnhance Choice Supply Box*10 ","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"Diamond*300\nFragmen Hero Universal 5★*8\nStar up II Choice Supply Box*10\nStar up Choice Supply Box*10\nEnhance Choice Supply Box*10 ","state":"0","dailyLimit":"","activityLimit":"1"}]},"ar-SA":{"giftIcon":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624733226693.png","title":`首储板块标题`,"activeTab":`team`,"taskLog":[
    {
        title: '每发起一次邀请',
        exp: '100',
    },
    {
        title: '每发起两次邀请',
        exp: '200',
    },
    {
        title: '每发起三次邀请',
        exp: '300',
    },
],"customEventList":[{"eventRefer":"","eventName":""}],"inviterDesc":``,"inviteeDesc":``,"teamTask":[{"taskValue":"pay_total","payLevelType":"customize_level","num":"500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791575806363.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png"],"awardDetail":"تسريع التدريب 10 دقائق*10\nتسريع الأبحاث 10 دقائق*10","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"1500","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635791569536182.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635793139189465.png"],"awardDetail":"الماس*50\nتسريع التدريب 10 دقائق\nتسريع الأبحاث 10 دقائق","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"3000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798962579308.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"الماس*100\nتسريع التدريب 5 دقائق\nتسريع الأبحاث 5 دقائق\nتسريع البناء 5 دقائق","state":"0","dailyLimit":"","activityLimit":""},{"taskValue":"pay_total","payLevelType":"customize_level","num":"5000","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854367812364194.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635798916096806.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797241192909.png"],"awardDetail":"الماس*200\nقطعة بطل متعددة 5★*1\nتسريع التدريب 5 دقائق\nتسريع الأبحاث 5 دقائق\nتسريع البناء 5 دقائق","state":"0","dailyLimit":"","activityLimit":""}],"soloTask":[{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到100USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797217184498.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/05/171635797264964897.png"],"awardDetail":"تسريع التدريب 10 دقائق*10\nتسريع الأبحاث 10 دقائق*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到300USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503718828406.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854503794489445.png"],"awardDetail":"الماس*150\nتسريع التدريب 10 دقائق\nتسريع الأبحاث 10 دقائق","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到600USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393660440712.png"],"awardDetail":"الماس*200\nقطعة بطل متعددة 5★*5\nصندوق ترقية النجوم*10\nاختيار صندوق الإمدادات*10","state":"0","dailyLimit":"","activityLimit":"1"},{"taskValue":"pay_total","payLevelType":"customize_level","taskName":"累充金额达到1000USD","pic":["https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393644156857.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854393692406100.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330325219221.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330323235319.png","https://cdnimages.awselbcombine.com/public_images/one_image/2024/10/172854330349282374.png"],"awardDetail":"الماس*300\nقطعة بطل متعددة 5★*8\nصندوق ترقية النجوم II*10\nصندوق ترقية النجوم*10\nاختيار صندوق الإمدادات*10","state":"0","dailyLimit":"","activityLimit":"1"}]}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '活动任务';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {});
const checkIsLogin = inject("checkIsLogin", () => {});
const listData = inject("listData", {});
const showTips = inject("showTips", (txt, code) => {});
const showGetSucc = inject("showGetSucc", (type, pic, name) => {});
const getAward = inject("getAward", (type, key) => {})
const giftInfo = inject("giftInfo", {});
const getCurLink = inject("getCurLink", (link) => {});
const openInvitePanel = inject("openInvitePanel", () => {})
const initActivity = inject("initActivity", () => {})
const canClickRefresh = inject("canClickRefresh", true);
compData.inviteeTaskList = [];
compData.inviterTaskList = [];
compData.inviteeOtherTaskList = [];
compData.activeTab = 'team';
let customEventIndex = 0; // 记录当前自定义事件下标
const firstInit = ref(true);
watch(
  () => listData,
  (value) => {
    customEventIndex = 0;
    if (value && value.teamTask) {
      value.teamTask.forEach((item, index) => {
        if (compData.teamTask[index] === undefined) {
          compData.teamTask[index] = {};
        }
        let pic = compData.teamTask[index].pic;
        let awardDetail = compData.teamTask[index].awardDetail;
        if (+item.ticket > 0 && firstInit.value) {
          compData.teamTask[index].pic = [pageData.lotteryIcon, ...pic];
          compData.teamTask[
            index
          ].awardDetail = `${langData.lotteryCoupon} *${item.ticket}、${awardDetail}`;
        }
        compData.teamTask[index].taskValue = item.sub_task_type;
        compData.teamTask[index].payLevelType = item.pay_level_type;
        compData.teamTask[index].num = item.each_pay;
        compData.teamTask[index].state = item.status;
        compData.teamTask[index].dailyLimit = item.limit?.daily_limit;
        compData.teamTask[index].activityLimit = item.limit?.activity_limit;
        compData.teamTask[index].key = item.key;
        let curTaskName =
          item.pay_level_type == "customize_level" ?
          langData.teamPayTotal :
          langData.teamPayEvery;
        // 储值任务名称加入官网储值标识
        if (item.task_type == "charge") {
          curTaskName = `${curTaskName}(${langData.officialPay})`;
        }
        compData.teamTask[index].taskName = curTaskName
          .replaceAll("${x}", item.reach || "")
          .replaceAll("${currency}", pageData.currency);
        // 自定义档位针对重置类型的处理
        if (item.pay_level_type == "customize_level") {
          compData.teamTask[index].dailyLimit =
            item.pay_reset_rule == "activity" ? -1 : 1;
          compData.teamTask[index].activityLimit =
            item.pay_reset_rule == "activity" ? 1 : -1;
        }
      });
      giftInfo.teamTask = compData.teamTask;
    }
    if (value && value.personalTask) {
      value.personalTask.forEach((item, index) => {
        if (compData.soloTask[index] === undefined) {
          compData.soloTask[index] = {};
        }
        let pic = compData.soloTask[index].pic;
        let awardDetail = compData.soloTask[index].awardDetail;
        if (+item.ticket > 0 && firstInit.value) {
          compData.soloTask[index].pic = [pageData.lotteryIcon, ...pic];
          compData.soloTask[
            index
          ].awardDetail = `${langData.lotteryCoupon} *${item.ticket}、${awardDetail}`;
        }
        compData.soloTask[index].taskValue = item.sub_task_type;
        compData.soloTask[index].payLevelType = item.pay_level_type;
        compData.soloTask[index].state = item.status;
        compData.soloTask[index].dailyLimit = item.limit?.daily_limit;
        compData.soloTask[index].activityLimit = item.limit?.activity_limit;
        compData.soloTask[index].key = item.key;
        let curTaskName =
          (item.sub_task_type === "events" ?
            compData.customEventList[customEventIndex++]?.eventName :
            langData[item.sub_task_type]) || '';
        if (item.pay_level_type == "customize_level") {
          curTaskName = langData.payTotalAll;
          // 自定义档位针对重置类型的处理
          compData.soloTask[index].dailyLimit =
            item.pay_reset_rule == "activity" ? -1 : 1;
          compData.soloTask[index].activityLimit =
            item.pay_reset_rule == "activity" ? 1 : -1;
        }
        if (item.pay_level_type == "fixed_level") {
          curTaskName = langData.pay_total;
        }
        // 储值任务名称加入官网储值标识
        if (item.task_type == "charge") {
          curTaskName = `${curTaskName}(${langData.officialPay})`;
        }
        compData.soloTask[index].taskName = curTaskName
          .replaceAll("${x}", item.reach || "")
          .replaceAll("${currency}", pageData.currency);
      });
      giftInfo.personalTask = compData.soloTask;
    }
    firstInit.value = false;
  }, {
    deep: true
  }
);
// 游戏内隐藏充值入口
const checkCanShow = (type) => {
  if (
        ["pay_total", "pay_order"].includes(type) &&
    bridge.runInsdk()
  ) {
    return false;
  }
  return true;
};

// 任务完成按钮文案
const getBtnText = (item) => {
  if (item.state == 1) {
    return langData.getBtn;
  }
  if (item.state == 2) {
    return langData.hasBtn;
  }
  if (item.taskValue == "pay_total" || item.taskValue == "pay_order") {
    return bridge.runInsdk() ? langData.noFinish : langData.toFinish;
  }
  if (
        [
          "first_login_game",
          "daily_login_game",
          "first_login_activity",
          "daily_login_activity",
          "events",
        ].includes(item.taskValue)
  ) {
    return langData.noFinish;
  } else {
    return langData.toFinish;
  }
};;
      // 队伍任务的click事件
      const u_c_OCV248_event_AXJ783= async (e)=>{
        try {compData.activeTab = 'team'} catch (error) {console.log(error)}
      };
      // 个人任务的click事件
      const u_c_MHT350_event_XSXX85= async (e)=>{
        try {compData.activeTab = 'personal'} catch (error) {console.log(error)}
      };
      // 刷新的click事件
      const u_c_KL1C31_event_Y90J29= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if(!canClickRefresh.value)return;
canClickRefresh.value = false;
initActivity();
await utils.sleep(5);
canClickRefresh.value = true;} catch (error) {console.log(error)}
      };
      // 我的背包的click事件
      const u_c_JGIQ33_event_Y90J29= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "活动任务-背包",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
pageData.curBagType = compData.activeTab == 'team' ? 'team_task' : 'personal_task'
pageData.bagPopupState = true} catch (error) {console.log(error)}
      };
      // 任务日志的click事件
      const u_c_6R6U21_event_Y90J29= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
pageData.curBagType = compData.activeTab == 'team' ? 'team_task' : 'personal_task'
pageData.taskLogPopupState = true} catch (error) {console.log(error)}
      };
      // 奖励项的click事件
      const u_c_67LY123_event_QUFC21= async (e,data)=>{
        try {showTips(data.awardDetail);} catch (error) {console.log(error)}
      };
      // 领取按钮的click事件
      const u_c_5EOB125_event_5IW625= async (e,taskItem,index)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (taskItem.state == 2) {
  // 已领取直接返回
  return;
}
const curType = compData.activeTab == 'team' ? 'team_task' : 'personal_task'

if (taskItem.state == 1) {
  // 领取奖励
  const res = getAward(curType, taskItem.key)
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "组队任务-领取按钮",
    eventReason: curType,
    eventValue: JSON.stringify(taskItem),
    gameId: pageData.gameId,
    aid: pageData.pageId,
  });
  // if (res.result == 1) {
  //   if (compData.activeTab == 'team') {
  //     compData.teamTask[index].state = 2;
  //     return;
  //   }
  //   compData.soloTask[index].state = 2;
  // }
  return;
}
// 未达成的情况
if (
  ["share_activity"].includes(
    taskItem.taskValue
  )
) {
  // 分享活动页面
  await openInvitePanel(true);
  
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "组队任务-分享任务",
    gameId: pageData.gameId,
    aid: pageData.pageId,
  });
  initActivity();
  return;
}
if (["pay_total", "pay_order"].includes(taskItem.taskValue)) {
  // 如果没有配置储值链接，不做任何操作
  if (!pageData.storeLink) {
    return;
  }
  // 如果游戏内访问，则不打开第三方链接
  if (bridge.runInsdk()) {
    return;
  }
  bridge.open(pageData.storeLink, "_blank");
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: "组队任务-跳转支付页",
    gameId: pageData.gameId,
    aid: pageData.pageId,
  });
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.default{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.default{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.default{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.default{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.default{
.u_c_Q9IQ53.normal{
position:relative;

}
}.default{
.u_c_RB2H54.normal{
position:relative;

}
}.default{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.default{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.default{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.default{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.default{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.default{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.default{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.default{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.default{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.default{
.u_c_PHDI21.normal{
position:relative;

}
}.default{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.default{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.default{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.default{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.default{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.default{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.default{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.default{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.default{
.u_c_U4BS22.normal{
position:relative;

}
}.default{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.zh-CN{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.zh-CN{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.zh-CN{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.zh-CN{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.zh-CN{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.zh-CN{
.u_c_Q9IQ53.normal{
position:relative;

}
}.zh-CN{
.u_c_RB2H54.normal{
position:relative;

}
}.zh-CN{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.zh-CN{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.zh-CN{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.zh-CN{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.zh-CN{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.zh-CN{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.zh-CN{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.zh-CN{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.zh-CN{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.zh-CN{
.u_c_PHDI21.normal{
position:relative;

}
}.zh-CN{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.zh-CN{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.zh-CN{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.zh-CN{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.zh-CN{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.zh-CN{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.zh-CN{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.zh-CN{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.zh-CN{
.u_c_U4BS22.normal{
position:relative;

}
}.zh-CN{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.zh-TW{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.zh-TW{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.zh-TW{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.zh-TW{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.zh-TW{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.zh-TW{
.u_c_Q9IQ53.normal{
position:relative;

}
}.zh-TW{
.u_c_RB2H54.normal{
position:relative;

}
}.zh-TW{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.zh-TW{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.zh-TW{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.zh-TW{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.zh-TW{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.zh-TW{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.zh-TW{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.zh-TW{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.zh-TW{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.zh-TW{
.u_c_PHDI21.normal{
position:relative;

}
}.zh-TW{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.zh-TW{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.zh-TW{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.zh-TW{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.zh-TW{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.zh-TW{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.zh-TW{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.zh-TW{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.zh-TW{
.u_c_U4BS22.normal{
position:relative;

}
}.zh-TW{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.en-US{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.en-US{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.en-US{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.en-US{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.en-US{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.en-US{
.u_c_Q9IQ53.normal{
position:relative;

}
}.en-US{
.u_c_RB2H54.normal{
position:relative;

}
}.en-US{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.en-US{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.en-US{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.en-US{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.en-US{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.en-US{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.en-US{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.en-US{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.en-US{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.en-US{
.u_c_PHDI21.normal{
position:relative;

}
}.en-US{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.en-US{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.en-US{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.en-US{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.en-US{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.en-US{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.en-US{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.en-US{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.en-US{
.u_c_U4BS22.normal{
position:relative;

}
}.en-US{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.ja-JP{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.ja-JP{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.ja-JP{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.ja-JP{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.ja-JP{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.ja-JP{
.u_c_Q9IQ53.normal{
position:relative;

}
}.ja-JP{
.u_c_RB2H54.normal{
position:relative;

}
}.ja-JP{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.ja-JP{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.ja-JP{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.ja-JP{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ja-JP{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ja-JP{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ja-JP{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.ja-JP{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.ja-JP{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ja-JP{
.u_c_PHDI21.normal{
position:relative;

}
}.ja-JP{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ja-JP{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ja-JP{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ja-JP{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.ja-JP{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.ja-JP{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.ja-JP{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.ja-JP{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.ja-JP{
.u_c_U4BS22.normal{
position:relative;

}
}.ja-JP{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.ko-KR{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.ko-KR{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.ko-KR{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.ko-KR{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.ko-KR{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.ko-KR{
.u_c_Q9IQ53.normal{
position:relative;

}
}.ko-KR{
.u_c_RB2H54.normal{
position:relative;

}
}.ko-KR{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.ko-KR{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.ko-KR{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.ko-KR{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ko-KR{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ko-KR{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ko-KR{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.ko-KR{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.ko-KR{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ko-KR{
.u_c_PHDI21.normal{
position:relative;

}
}.ko-KR{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ko-KR{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ko-KR{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ko-KR{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.ko-KR{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.ko-KR{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.ko-KR{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.ko-KR{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.ko-KR{
.u_c_U4BS22.normal{
position:relative;

}
}.ko-KR{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.th-TH{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.th-TH{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.th-TH{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.th-TH{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.th-TH{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.th-TH{
.u_c_Q9IQ53.normal{
position:relative;

}
}.th-TH{
.u_c_RB2H54.normal{
position:relative;

}
}.th-TH{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.th-TH{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.th-TH{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.th-TH{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.th-TH{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.th-TH{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.th-TH{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.th-TH{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.th-TH{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.th-TH{
.u_c_PHDI21.normal{
position:relative;

}
}.th-TH{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.th-TH{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.th-TH{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.th-TH{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.th-TH{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.th-TH{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.th-TH{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.th-TH{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.th-TH{
.u_c_U4BS22.normal{
position:relative;

}
}.th-TH{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.vi-VN{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.vi-VN{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.vi-VN{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.vi-VN{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.vi-VN{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.vi-VN{
.u_c_Q9IQ53.normal{
position:relative;

}
}.vi-VN{
.u_c_RB2H54.normal{
position:relative;

}
}.vi-VN{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.vi-VN{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.vi-VN{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.vi-VN{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.vi-VN{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.vi-VN{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.vi-VN{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.vi-VN{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.vi-VN{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.vi-VN{
.u_c_PHDI21.normal{
position:relative;

}
}.vi-VN{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.vi-VN{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.vi-VN{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.vi-VN{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.vi-VN{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.vi-VN{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.vi-VN{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.vi-VN{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.vi-VN{
.u_c_U4BS22.normal{
position:relative;

}
}.vi-VN{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.de-DE{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.de-DE{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.de-DE{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.de-DE{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.de-DE{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.de-DE{
.u_c_Q9IQ53.normal{
position:relative;

}
}.de-DE{
.u_c_RB2H54.normal{
position:relative;

}
}.de-DE{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.de-DE{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.de-DE{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.de-DE{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.de-DE{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.de-DE{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.de-DE{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.de-DE{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.de-DE{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.de-DE{
.u_c_PHDI21.normal{
position:relative;

}
}.de-DE{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.de-DE{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.de-DE{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.de-DE{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.de-DE{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.de-DE{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.de-DE{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.de-DE{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.de-DE{
.u_c_U4BS22.normal{
position:relative;

}
}.de-DE{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.fr-FR{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.fr-FR{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.fr-FR{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.fr-FR{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.fr-FR{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.fr-FR{
.u_c_Q9IQ53.normal{
position:relative;

}
}.fr-FR{
.u_c_RB2H54.normal{
position:relative;

}
}.fr-FR{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.fr-FR{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.fr-FR{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.fr-FR{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.fr-FR{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.fr-FR{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.fr-FR{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.fr-FR{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.fr-FR{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.fr-FR{
.u_c_PHDI21.normal{
position:relative;

}
}.fr-FR{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.fr-FR{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.fr-FR{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.fr-FR{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.fr-FR{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.fr-FR{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.fr-FR{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.fr-FR{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.fr-FR{
.u_c_U4BS22.normal{
position:relative;

}
}.fr-FR{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.ru-RU{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.ru-RU{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.ru-RU{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.ru-RU{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.ru-RU{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.ru-RU{
.u_c_Q9IQ53.normal{
position:relative;

}
}.ru-RU{
.u_c_RB2H54.normal{
position:relative;

}
}.ru-RU{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.ru-RU{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.ru-RU{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.ru-RU{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ru-RU{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ru-RU{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ru-RU{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.ru-RU{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.ru-RU{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ru-RU{
.u_c_PHDI21.normal{
position:relative;

}
}.ru-RU{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ru-RU{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ru-RU{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ru-RU{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.ru-RU{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.ru-RU{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.ru-RU{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.ru-RU{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.ru-RU{
.u_c_U4BS22.normal{
position:relative;

}
}.ru-RU{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.es-ES{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.es-ES{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.es-ES{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.es-ES{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.es-ES{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.es-ES{
.u_c_Q9IQ53.normal{
position:relative;

}
}.es-ES{
.u_c_RB2H54.normal{
position:relative;

}
}.es-ES{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.es-ES{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.es-ES{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.es-ES{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.es-ES{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.es-ES{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.es-ES{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.es-ES{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.es-ES{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.es-ES{
.u_c_PHDI21.normal{
position:relative;

}
}.es-ES{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.es-ES{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.es-ES{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.es-ES{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.es-ES{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.es-ES{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.es-ES{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.es-ES{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.es-ES{
.u_c_U4BS22.normal{
position:relative;

}
}.es-ES{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.pt-PT{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.pt-PT{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.pt-PT{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.pt-PT{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.pt-PT{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.pt-PT{
.u_c_Q9IQ53.normal{
position:relative;

}
}.pt-PT{
.u_c_RB2H54.normal{
position:relative;

}
}.pt-PT{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.pt-PT{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.pt-PT{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.pt-PT{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.pt-PT{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.pt-PT{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.pt-PT{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.pt-PT{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.pt-PT{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.pt-PT{
.u_c_PHDI21.normal{
position:relative;

}
}.pt-PT{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.pt-PT{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.pt-PT{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.pt-PT{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.pt-PT{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.pt-PT{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.pt-PT{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.pt-PT{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.pt-PT{
.u_c_U4BS22.normal{
position:relative;

}
}.pt-PT{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.it-IT{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.it-IT{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.it-IT{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.it-IT{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.it-IT{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.it-IT{
.u_c_Q9IQ53.normal{
position:relative;

}
}.it-IT{
.u_c_RB2H54.normal{
position:relative;

}
}.it-IT{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.it-IT{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.it-IT{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.it-IT{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.it-IT{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.it-IT{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.it-IT{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.it-IT{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.it-IT{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.it-IT{
.u_c_PHDI21.normal{
position:relative;

}
}.it-IT{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.it-IT{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.it-IT{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.it-IT{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.it-IT{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.it-IT{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.it-IT{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.it-IT{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.it-IT{
.u_c_U4BS22.normal{
position:relative;

}
}.it-IT{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.tr-TR{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.tr-TR{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.tr-TR{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.tr-TR{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.tr-TR{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.tr-TR{
.u_c_Q9IQ53.normal{
position:relative;

}
}.tr-TR{
.u_c_RB2H54.normal{
position:relative;

}
}.tr-TR{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.tr-TR{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.tr-TR{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.tr-TR{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.tr-TR{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.tr-TR{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.tr-TR{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.tr-TR{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.tr-TR{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.tr-TR{
.u_c_PHDI21.normal{
position:relative;

}
}.tr-TR{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.tr-TR{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.tr-TR{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.tr-TR{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.tr-TR{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.tr-TR{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.tr-TR{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.tr-TR{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.tr-TR{
.u_c_U4BS22.normal{
position:relative;

}
}.tr-TR{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.pl-PL{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.pl-PL{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.pl-PL{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.pl-PL{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.pl-PL{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.pl-PL{
.u_c_Q9IQ53.normal{
position:relative;

}
}.pl-PL{
.u_c_RB2H54.normal{
position:relative;

}
}.pl-PL{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.pl-PL{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.pl-PL{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.pl-PL{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.pl-PL{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.pl-PL{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.pl-PL{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.pl-PL{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.pl-PL{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.pl-PL{
.u_c_PHDI21.normal{
position:relative;

}
}.pl-PL{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.pl-PL{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.pl-PL{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.pl-PL{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.pl-PL{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.pl-PL{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.pl-PL{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.pl-PL{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.pl-PL{
.u_c_U4BS22.normal{
position:relative;

}
}.pl-PL{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.id-ID{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.id-ID{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.id-ID{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.id-ID{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.id-ID{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.id-ID{
.u_c_Q9IQ53.normal{
position:relative;

}
}.id-ID{
.u_c_RB2H54.normal{
position:relative;

}
}.id-ID{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.id-ID{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.id-ID{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.id-ID{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.id-ID{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.id-ID{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.id-ID{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.id-ID{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.id-ID{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.id-ID{
.u_c_PHDI21.normal{
position:relative;

}
}.id-ID{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.id-ID{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.id-ID{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.id-ID{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.id-ID{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.id-ID{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.id-ID{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.id-ID{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.id-ID{
.u_c_U4BS22.normal{
position:relative;

}
}.id-ID{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}.ar-SA{
.u_c_DIDC46.normal{
position:relative;
width:9.23rem;
background:no-repeat center;
background-size:cover;
overflow:hidden;
font-size:0;
margin:auto;
padding-bottom:1.33rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559006024-10.png);
margin-top:0.67rem;
border-radius:0.27rem;

}

.u_c_DIDC46.normal .task-text{
font-size:0.33rem;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-title{
font-size:0.40rem;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .exp-detail{
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-desc{
font-size:0.29rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}

.u_c_DIDC46.normal .task-bg{
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170132896553730861.png);
background-size:100% 100%;

}
}.ar-SA{
.u_c_TCEI47.normal{
position:relative;
width:6.04rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
justify-content:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005552-88.png);
box-sizing:border-box;
padding:0.20rem;
min-height:1.07rem;

}

.u_c_TCEI47.normal .active-tab{
opacity:1;

}
}.ar-SA{
.u_c_OCV248.normal{
position:relative;
opacity:0.5;
cursor:pointer;

}
}.ar-SA{
.u_c_MHT350.normal{
position:relative;
opacity:0.5;
cursor:pointer;
margin-left:0.67rem;

}
}.ar-SA{
.u_c_H0UU52.normal{
position:relative;
margin-top:0.31rem;
box-sizing:border-box;
padding:0 0.27rem;

}
}.ar-SA{
.u_c_Q9IQ53.normal{
position:relative;

}
}.ar-SA{
.u_c_RB2H54.normal{
position:relative;

}
}.ar-SA{
.u_c_77JA97.normal{
position:relative;
width:8.35rem;
height:0.83rem;
margin:0 auto;
margin-top:0.35rem;
display:flex;
justify-content:center;
align-items:center;
font-size:0.31rem;
background-color:#414771;
border-radius:0.47rem;
border:3px solid;
border-color:#ffdd7b;
font-weight:normal;

}
}.ar-SA{
.u_c_A786102.normal{
position:relative;
padding:0 0.07rem;

}
}.ar-SA{
.u_c_Q26230.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.23rem;

}
}.ar-SA{
.u_c_KL1C31.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
line-height:1.5;
text-decoration:underline;
text-align:center;
cursor:pointer;

}
}.ar-SA{
.u_c_JGIQ33.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ar-SA{
.u_c_6R6U21.normal{
position:relative;
box-sizing:border-box;
padding:0.13rem;
text-align:center;
line-height:1.5;
text-decoration:underline;
cursor:pointer;

}
}.ar-SA{
.u_c_EQ6B133.normal{
position:relative;
width:100%;
height:11.65rem;
overflow-y:auto;
margin-top:0.48rem;

}
}.ar-SA{
.u_c_0PIV116.normal{
position:relative;
margin-bottom:0.67rem;

}
}.ar-SA{
.u_c_IXM3117.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ar-SA{
.u_c_PHDI21.normal{
position:relative;

}
}.ar-SA{
.u_c_C09Q26.normal{
position:relative;
padding-left:0.40rem;
margin-bottom:0.11rem;

}
}.ar-SA{
.u_c_9F94121.normal{
position:relative;
height:1.55rem;
width:8.39rem;
background:no-repeat center;
background-size:100% 100%;
margin:0 auto;
display:flex;
align-items:center;
justify-content:space-between;
padding-right:0.13rem;
box-sizing:border-box;

}
}.ar-SA{
.u_c_8YAC122.normal{
position:relative;
height:100%;
width:6.33rem;
display:flex;
align-items:center;
overflow-x:auto;

}
}.ar-SA{
.u_c_67LY123.normal{
position:relative;
width:1.23rem;
height:1.23rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559005491-4.png);
display:flex;
justify-content:center;
align-items:center;
margin-right:0.27rem;
flex-shrink:0;

}
}.ar-SA{
.u_c_CIKY124.normal{
position:relative;
width:0.91rem;
height:0.93rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697582-68.png);

}
}.ar-SA{
.u_c_5EOB125.normal{
position:relative;
width:2.03rem;
height:1.31rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697541-29.png);
font-size:0.33rem;
color:#fff;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
text-align:center;

}

.u_c_5EOB125.normal.has{
filter:grayscale(1);

}
}.ar-SA{
.u_c_SGL619.normal{
position:relative;
font-size:0.27rem;
padding-left:0.21rem;
margin-bottom:0;
width:8.68rem;
height:0.92rem;
margin:0 auto;
display:flex;
align-items:center;
margin-top:0.07rem;
background-color:#414771;
border-radius:0.07rem;
box-sizing:border-box;

}
}.ar-SA{
.u_c_LM5020.normal{
position:relative;
margin-right:0.27rem;

}
}.ar-SA{
.u_c_U4BS22.normal{
position:relative;

}
}.ar-SA{
.u_c_YLSD24.normal{
position:relative;
margin:0 0.27rem;

}
}
</style>
